
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.55774 18.228C8.19511 17.8654 8.19511 17.2775 8.55774 16.9148L13.4726 12L8.55774 7.08517C8.19511 6.72254 8.19511 6.1346 8.55774 5.77197C8.92037 5.40934 9.50831 5.40934 9.87094 5.77197L15.4424 11.3434C15.805 11.706 15.805 12.294 15.4424 12.6566L9.87094 18.228C9.50831 18.5907 8.92037 18.5907 8.55774 18.228Z","fill":"#16171F"}})])
          )
        }
      }
    